import React, { useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';

function Cancelbill() {

    const [registrationNo, setRegistrationNo] = useState('');
    const [billdate, setBillDate] = useState('');
    const [result, setResult] = useState(null);

    const handlecancelbill = async (billNo) => {
        const result = Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Cancel this Bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Cancel it!',
        });

        if ((await result).isConfirmed) {
            console.log("inrequest: ", billNo)
            try {
                const response = await axios.put(
                    `https://api.sivammoto.in/api/cancelbill/${billNo}`,
                    {}, // Empty body
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                );
                console.log(response.data);
                Swal.fire('Deleted!', 'The bill has been Cancelled.', 'success');
                handleClear();
            } catch (error) {
                console.error('Error fetching data', error);
                Swal.fire('Error', error.response?.data?.error, 'error');
                if (error.response) {
                    // Server responded with a status code outside the 2xx range
                    Swal.fire('Error', error.response.data.error || 'An error occurred.', 'error');
                } else if (error.request) {
                    // Request was made but no response was received
                    Swal.fire('Error', 'No response from server. Please check your connection.', 'error');
                } else {
                    // Other errors
                    Swal.fire('Error', error.message, 'error');
                }
            }


        }
    };

    const handleSearch = async (e) => {
        e.preventDefault();

        if ((!registrationNo || !billdate)) {
            Swal.fire('Error!', 'Please Give the value to search for Bill Details', 'error');
            return;
        }

        try {
            const response = await axios.post('https://api.sivammoto.in/api/cancelbill/searchbill', {
                reg_no: registrationNo,
                billdate: billdate
            });
            console.log(response.data)
            setResult(response.data);
        } catch (error) {
            console.error('Error fetching data', error);
            Swal.fire('Error', error.response?.data?.error, 'error');
        }
    };

    const handleClear = () => {
        setResult('');
        setRegistrationNo('');
        setBillDate('');
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Cancel Billing</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Cancel Billing</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-10">
                        <form onSubmit={handleSearch}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }}>
                            <div className="row">
                                <div className="col-md-10 offset-md-1">
                                    <div className="row mt-2">
                                        <div className="col-md-6">
                                            <div className="row align-items-center">
                                                <div className="col-md-6">
                                                    <label>Registration No:</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <input type="input" className="form-control" placeholder="Type a Registration No" value={registrationNo} onChange={(e) => setRegistrationNo(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row align-items-center">
                                                <div className="col-md-6">
                                                    <label>Bill Date:</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <input type="date" className="form-control" value={billdate} onChange={(e) => setBillDate(e.target.value)} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-6"></div>
                                        <div className="col-md-6">
                                            <div className="form-group align-items-center">
                                                <button className="btn btn-primary mb-5 mr-2">Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-2">
                        <div className="col-auto align-self-center">
                            <button className="btn btn-primary mb-5 mr-2" onClick={handleClear}>Clear</button>
                        </div>
                    </div>
                </div>

                {result && (
                    <div className="row mt-2">
                        <div className='col-md-2'></div>
                        <div className="col-md-8">
                            <div className="card card-warning">
                                <div className="card-header">
                                    <h3 className="card-title" style={{ textAlign: "center" }}>Bill Details</h3>
                                </div>
                                <div className="card-body" style={{ background: "cornsilk" }}>
                                    <form onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                        }
                                    }}>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="row align-items-center">
                                                    <div className="col-md-4">
                                                        <label>Bill No :</label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <label>{result.bill_data.id}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-sm-6'>
                                                <div className="row align-items-center">
                                                    <div className="col-md-4">
                                                        <label>Registration No :</label>
                                                    </div>
                                                    <label>{result.registration_no || "No registration number available"}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="row align-items-center">
                                                    <div className="col-md-4">
                                                        <label>Date :</label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <label>{result.bill_data.date}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="row align-items-center">
                                                    <div className="col-md-4">
                                                        <label>Name :</label>
                                                    </div>
                                                    <label>{result.bill_data.to_name}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="row align-items-center">
                                                    <div className="col-md-4">
                                                        <label>Address :</label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <label>{result.bill_data.to_address1}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="row align-items-center">
                                                    <div className="col-md-4">
                                                        <label>City / District :</label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <label>{result.bill_data.to_city}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr style={{ borderTop: "1px solid #0000FF" }} />
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="row align-items-center">
                                                    <div className="col-md-6">
                                                        <label>Vechicle :</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>{result.bill_data.ref_vehicle_type}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="row align-items-center">
                                                    <div className="col-md-6">
                                                        <label>Amount :</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>{result.bill_data.ref_amount}</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4 text-right">
                                                <button type="button" className="btn btn-primary" onClick={() => handlecancelbill(result.bill_data.id)}>Cancel Bill</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>

    )
}

export default Cancelbill